
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10z","fill":"#F35"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.767 6.267a.566.566 0 11.8.8L8.9 13.733a.566.566 0 01-.8 0L4.767 10.4a.566.566 0 11.8-.8L8.5 12.532l6.267-6.265z","fill":"#fff"}})])
          )
        }
      }
    